import { render, staticRenderFns } from "./TransactionPurposes.vue?vue&type=template&id=199b99b4&scoped=true&"
import script from "./TransactionPurposes.vue?vue&type=script&lang=js&"
export * from "./TransactionPurposes.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPurposes.vue?vue&type=style&index=0&id=199b99b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b99b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
